export const WEEK_GROUP = 'week';
export const MONTH_GROUP = 'month';
export const QUARTER_GROUP = 'quarter';
export const TIMELINE_FILTER_ID = 'projectDetailTimeline';
export const ADD_TOP = 'top';
export const ADD_BOTTOM = 'bottom';
